import { Box } from '@mui/material';
import { useEffect } from 'react';

export default function Connect() {
  useEffect(() => {
    // Set background color on body for this page
    document.body.style.backgroundColor = '#f0ecf3';

    return () => {
      // Reset background color when leaving
      document.body.style.backgroundColor = '';
    };
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSdnSo4I9Rc5wu6R5rHt0b0-gC5kCCZ1WHr-MDRdzI719_oHYw/viewform"
        width="100%"
        style={{
          height: '90vh',
          border: 'none',
          borderRadius: '8px'
        }}
      >
        Loading…
      </iframe>
    </Box>
  );
}
